import type { WithdrawalConfig } from '../../withdrawal.types.ts';

const WITHDRAWAL: WithdrawalConfig = {
  bankFields: ['bankCode', 'accountNumber', 'accountName'],
  accountNumber: { minDigits: 5, maxDigits: 10 },
  bankCode: { groupSizes: [3, 3], trackName: 'BSB' },
  allowedInstrumentTypes: ['BANKTRANSFER'],
};

export { WITHDRAWAL };
